module.exports = __webpack_public_path__ + "static/media/Upload Files.578dde97.svg";